import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import ThemeAImageWithText from '../../../components/ThemeAImageWithText';

export default function AboutUs({ global, all_our_values_image_with_text }) {
  return (
    <>
      <SeoHead
        page_name={`Our Values | Project engineering and technical recruitment specialists | Carbon60`}
      />
      <MainBanner
        global={global}
        pathPrefix={`our_values_page.main_banner`}
        customClass={``}
        content={``}
        imageURL1={`/site-assets/images/about-us-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
      />
      <ThemeAImageWithText
        global={global}
        pathPrefix={`our_values_page.theme_a_image_with_text`}
        customClass={`py-5 grayGradientBg`}
        post={all_our_values_image_with_text}
        videoGalleryClass={`values`}
        content={
          ``}
        buttonLink={``}
        buttonTitle={``}
        primaryBtn={true}
      />
    </>
  )
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  const all_our_values_image_with_text = (await Collection('our_values_image_with_text')).orderBy('_order').getItems();

  return {
    props: {
      global,
      all_our_values_image_with_text
    }
  };
}